<template>
  <Button v-bind="buttonProps" @click="toggle">{{ buttonText }}</Button>
</template>

<script setup lang="ts">
import { Button } from '@hypercodestudio/basler-components';
import type { Props as ButtonProps } from '@hypercodestudio/basler-components/dist/components/elements/Button.vue';
import * as typeformCreatePopup from '@typeform/embed';

import '@typeform/embed/build/css/popup.css';

interface Props {
  typeformId: string;
  buttonText?: string;
  buttonProps?: ButtonProps;
}

const props = defineProps<Props>();
const toggle = ref<() => void>(() => {});

onMounted(() => {
  const { toggle: internalToggle } = typeformCreatePopup.createPopup(
    props.typeformId,
    {
      size: 80
    }
  );

  toggle.value = internalToggle;
});
</script>
